import { z } from 'zod';
import type { TFunction } from 'i18next';

export function createSalespersonSchema(t: TFunction) {
  return z.object({
    firstName: z.string().min(1, t('createSalesperson.nameRequired')),
    lastName: z.string().min(1, t('createSalesperson.lastNameRequired')),
    email: z.string().email(t('createSalesperson.emailInvalid')),
    phone: z.string().optional(),
    password: z.string().min(8, t('createSalesperson.passwordMin')),
    teamId: z.string().min(1, t('createSalesperson.teamRequired')),
  });
}

export type CreateSalespersonFormValues = z.infer<ReturnType<typeof createSalespersonSchema>>;
